<template>
  <header class="video-header">

    <!--
    <div class="fixed-bar" @click="openDialog" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="1000">
      <p>{{ $t('premiere_invitation') }}</p>
    </div>
    -->


    <video autoplay loop muted playsinline class="background-video">
      <source :src="videoSource" type="video/mp4" />
      Váš prohlížeč nepodporuje video tag.
    </video>

    <div class="header-content">
      <div class="hamburger" @click="toggleMenu">
        <i v-if="!isMenuOpen" class="pi pi-bars hamburger-icon"></i>
        <i v-else class="pi pi-times close-icon"></i>
      </div>
      <nav :class="{ open: isMenuOpen }" class="navigation">
        <ul>
          <li><a href="#about-film" @click="closeMenu">{{ $t('about') }}</a></li>
          <li><a href="#trailer" @click="closeMenu">{{ $t('trailer') }}</a></li>
          <li><a href="#cast" @click="closeMenu">{{ $t('cast') }}</a></li>
          <li><a href="#crew" @click="closeMenu">{{ $t('crew') }}</a></li>
          <li><a href="#gallery" @click="closeMenu">{{ $t('gallery') }}</a></li>
          <li><a href="#contact" @click="closeMenu">{{ $t('contact') }}</a></li>

          <!--
          <li>
            <button class="button button-success button-menu-center" @click="buyTicket">
              <i class="pi pi-ticket"></i>
              {{ $t('buy_ticket') }}
            </button>
          </li>
         -->
        </ul>
        <LanguageSwitcher class="language-switcher" />
      </nav>

      <h1 class="title" data-aos="fade-up" data-aos-duration="1500">{{ $t('title') }}</h1>

      <a href="#about-film" class="scroll-indicator">
        <i class="pi pi-angle-down"></i>
      </a>
    </div>

    <!-- Naše modální okno -->
    <ModalComponent :visible="dialogVisible" title="Premiéra filmu" @close="closeDialog">
      <template v-slot:default>
        <div class="modal-content">
          <div class="event-header">
            <h2 class="event-title">{{ $t('title_modal') }}</h2>
            <div class="event-datetime">
              <div class="date-badge">
                <i class="pi pi-calendar"></i>
                <span>11.6.2025</span>
              </div>
              <div class="time-badge">
                <i class="pi pi-clock"></i>
                <span>19:00</span>
              </div>
              <div class="location-badge">
                <i class="pi pi-map-marker"></i>
                <span>Praha</span>
              </div>
            </div>
          </div>
          <!--
          <img src="/img/plakat-event.jpg" alt="Film Poster" class="poster-image" />
          -->
        </div>
      </template>
      <template v-slot:footer>
        <button class="button button-calendar" @click="addToGoogleCalendar">
          <i class="pi pi-calendar"></i>
          Přidat do Google Kalendáře
        </button>
        <button class="button button-success" @click="buyTicket">
          <i class="pi pi-ticket"></i>
          Koupit lístek
        </button>
      </template>
    </ModalComponent>
  </header>
</template>
<script>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import ModalComponent from "@/components/ModalComponent.vue";

export default {
  name: 'VideoHeaderComponent',
  components: {
    ModalComponent,
    LanguageSwitcher
  },
  data() {
    return {
      isMenuOpen: false,
      dialogVisible: false,
      videoSource: '',
    };
  },
  mounted() {
    this.setVideoSource();
    window.addEventListener('resize', this.setVideoSource);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setVideoSource);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : 'auto';
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.body.style.overflow = 'auto';
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    addToGoogleCalendar() {
      window.open('https://calendar.google.com/calendar/render?action=TEMPLATE&text=Projekce+s+debatou+-+Mistr+housla%C5%99&details=Speci%C3%A1ln%C3%AD+projekce+s+n%C3%A1slednou+diskuz%C3%AD+v+Praze&location=Praha&dates=20250611T170000Z/20250611T190000Z');
    },
    buyTicket() {
      window.open('https://www.mlp.cz/cz/akce/e33781-mistr-houslar/', '_blank');
    },
    setVideoSource() {
      const screenWidth = window.innerWidth;
      if (screenWidth < 768) {
        this.videoSource = '/video/header_video_mobile.mp4';
      } else {
        this.videoSource = '/video/header_video.mp4';
      }
    }
  },
};
</script>


<style scoped>
.video-header {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
}

.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fixed-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  padding: 9px;
  background-color: #0a2224db;
  color: #ffe69c;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
  transition: all .2s ease-out;
  opacity: 1;
  &:hover {
    color: #cab36f;
  }
}

span {
  font-family: "Raleway", sans-serif;
}

.fixed-bar p {
  margin: 0;
  font-size: 1.0rem;
  font-weight: 400;
}

/* Stylování dialogu */
.poster-image {
  width: 100%;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.modal-content {
  padding: 10px;
}

.event-header {
  background-color: #0a2224;
  border-radius: 8px;
  padding: 20px;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
}

.event-title {
  margin: 0 0 15px 0;
  font-size: 1.8rem;
  color: #ffe69c;
}

.event-datetime {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.date-badge,
.time-badge,
.location-badge {
  display: flex;
  align-items: center;
  background-color: rgba(255, 230, 156, 0.2);
  padding: 8px 15px;
  border-radius: 20px;
  font-weight: 500;
}

.date-badge i,
.time-badge i,
.location-badge i {
  margin-right: 8px;
  color: #ffe69c;
}

.header-content {
  position: relative;
  z-index: 1;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  padding: 2rem;
}

/* Hamburger ikona */
.hamburger {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 100;
}

.hamburger-icon,
.close-icon {
  font-size: 2rem;
  color: white;
  z-index: 999999;
  position: relative;
  margin-top: 10px;
}

@media (min-width: 1100px) {
  .hamburger {
    display: none; /* Skrytí hamburger ikony */
  }
}

.navigation {
  position: fixed;
  top: 0;
  right: -100%; /* Skryto mimo obrazovku */
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  transition: right 0.4s ease;
}


.navigation.open {
  right: 0;
}

.navigation ul {
  list-style: none;
  gap: 2.5rem;
  margin-top: 40px;
  margin-right: 50px;
}

.navigation li {
  margin: 2rem 0;
}

.navigation a {
  color: #fff;
  text-decoration: none;
  font-size: 1.0rem;
  text-transform: uppercase;
  transition: opacity 0.3s ease-in-out;
}

.navigation a:hover {
  opacity: 0.7;
}


@media (min-width: 1100px) {
  .navigation {
    position: absolute;
    top: 20px;
    right: 20px;
    width: auto;
    height: auto;
    display: flex;
    flex-direction: row;
    background-color: transparent;
    justify-content: flex-end;
  }

  .navigation ul {
    display: flex;
  }

  .navigation li {
    margin: 0 1rem;
  }

  .button-menu-center {
    margin-top: -20px;
  }

}

/* Styl pro nadpis */
.title {
  font-weight: 400;
  font-size: 4rem;
}

/* Skrolovací indikátor */
.scroll-indicator {
  position: absolute;
  bottom: 120px;
  font-size: 3rem;
  cursor: pointer;
  color: white;
  animation: bounce 3s infinite;
}

@media (max-width: 768px) {
  .scroll-indicator {
    position: absolute;
    bottom: 81px;
  }

  .event-datetime {
    flex-direction: column;
    gap: 10px;
  }

  .date-badge,
  .time-badge,
  .location-badge {
    width: 100%;
    justify-content: center;
  }
}


@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }
}
</style>